import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        if (data.session_token) localStorage.setItem("dr_token", data.session_token);
        setUser(data.user);
        window.history.replaceState(null, "", "/lobby");
        navigate("/lobby", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090B0E]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-[#9CA3AF] font-head">Entrando na mesa...</p>
      </div>
    </div>
  );
}
